export default __webpack_public_path__ + "static/media/demo_assembly.b1200f65.png";